import { defineNuxtPlugin, useRouter, useRuntimeConfig, watch } from "#imports";
import adapter from "#vuepal/adapter";
function buildMapping(staticNodes = []) {
  return (staticNodes || []).reduce((acc, v) => {
    if (v.node?.id && v.key) {
      const languageMapping = (v.node.translations || []).reduce((aliases, link) => {
        const id = link.langcode;
        const url = link.url?.path;
        if (id && url) {
          aliases[id] = url;
        }
        return aliases;
      }, {});
      acc[v.key] = { languageMapping };
    }
    return acc;
  }, {});
}
export default defineNuxtPlugin({
  async setup() {
    const router = useRouter();
    const language = adapter.getCurrentLanguage();
    const config = useRuntimeConfig();
    const staticRoutes = router.getRoutes().filter((v) => !!v.meta.staticDrupalPage);
    const keys = staticRoutes.map((v) => v.meta.staticDrupalPage);
    if (!keys.length) {
      return;
    }
    const nodes = await adapter.getStaticNodes();
    const mapped = buildMapping(nodes);
    async function setStaticRoutes() {
      staticRoutes.forEach((route) => {
        if (!route.name) {
          return;
        }
        const staticKey = route.meta.staticDrupalPage;
        if (!staticKey || typeof staticKey !== "string") {
          return;
        }
        const routeMapping = mapped[staticKey];
        if (!routeMapping) {
          return;
        }
        router.removeRoute(route.name);
        if (config.public.useStaticNodesWithPrefix) {
          Object.entries(routeMapping.languageMapping).forEach(
            ([langcode, path]) => {
              const translatedRoute = {
                ...route,
                path: path.replace(/^\/([^/]+)/, "/:prefix()"),
                name: langcode + "--" + route.name?.toString()
              };
              router.addRoute(translatedRoute);
            }
          );
        } else {
          route.meta.languageMapping = routeMapping.languageMapping;
          router.addRoute({ ...route });
        }
      });
    }
    await setStaticRoutes();
    if (!config.public.useStaticNodesWithPrefix) {
      watch(language, async () => {
        await setStaticRoutes();
      });
    }
  }
});
